import { RichText } from '@sitecore-jss/sitecore-jss-react';
import React, { FC } from 'react';
import { CustomText } from '../../../@shared/customText';
import { TCardText } from '../../types/cardColumnLayout.types';

const CardText: FC<TCardText> = ({ title, subheading, cardHeadingTag }) => (
  <>
    {title && <CustomText tag={cardHeadingTag} field={title} className={'card__title'} />}
    {subheading && <RichText tag="div" field={subheading} className={'card__description rich-text color-primary-link'} />}
  </>
);

export default CardText;
